<template>
  <command-bar :showToglleBtn="true"
               :commanderList="therapyCommandss" />
</template>

<script>
import CommandBar from '@views/components/CommandBar'
import { mapMutations, mapActions } from 'vuex'

export default {
  components: {
    CommandBar,
  },
  data() {
    return {
      therapyCommandss: [
        {
          name: '结束',
          command: this._endThearapy,
          icon: 'PowerButton',
        },
        // {
        //   name: '多屏操作',
        //   command: this.mutiScreen,
        //   icon: 'FullScreen',
        // },
        {
          name: '设置',
          command: _ => this['therapy/updateStatus']('pause'),
          icon: 'Settings',
        },
        {
          name: '返回',
          command: this.routerBack,
          icon: 'Back',
        },
      ],
    }
  },
  methods: {
    ...mapMutations(['therapy/updateStatus']),
    ...mapActions(['EndTherapy']),
    _endThearapy() {
      // if (this.$refs.dataPanel && this.$refs.dataPanel.endCountDown) {
      //   this.$refs.dataPanel.endCountDown()
      // }
      // this.setScreenStatus(false)
      this.EndTherapy()
    },
    mutiScreen() {
      window.tdFrame = window.open('/#/3d', 'tdFrame', '_blank')
    },
    routerBack() {
      this.$router.go(-1)
    },
  },
}
</script>
